export default __webpack_public_path__ + "static/media/NotoSansKR-Regular.e95adf0e.woff2";